/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.19.0
 */

import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

import { TTableColumnCell } from '@modules/table/types';

import { TableCell } from '../index';
import TableCellNoValue from '../TableCellNoValue';
import { TTableCellText } from './types';


function TableCellText<D extends object>(cell: TTableCellText<D>): Pick<TTableColumnCell<D>, 'Cell'> {
    return {
        Cell: props => TableCell(props)({
            render: ({ row }) => {
                const value = cell(row);
                if (isString(value) || (isNumber(value) && value !== 0)) {
                    return <div
                        className="table__tooltip-text"
                        dangerouslySetInnerHTML={{ __html: String(value) }} />;
                }
                return <TableCellNoValue/>;
            },
        }),
    };
}

export default TableCellText;
